export const SEARCH_LATE_ACTIVATED_TXN = "SEARCH_LATE_ACTIVATED_TXN";
export const SEARCH_LATE_ACTIVATED_TXN_SUCCESSFULL = "SEARCH_LATE_ACTIVATED_TXN_SUCCESSFULL";
export const SEARCH_LATE_ACTIVATED_TXN_FAILED = "SEARCH_LATE_ACTIVATED_TXN_FAILED";
export const RESET_LATE_ACTIVATED_TXN_REPORT_PAGE="RESET_LATE_ACTIVATED_TXN_REPORT_PAGE";